import { createGlobalStyle } from "styled-components";



import "./reset.css"

const GlobalStyle = createGlobalStyle`
  :root {
    //main
    --primary-blue: hsl(246, 80%, 60%);
    --dark-blue: hsl(235, 46%, 20%);
    --darkest-blue:  hsl(226, 43%, 10%);
    --desaturated-blue: hsl(235, 45%, 61%);
    --pale-blue: hsl(236, 100%, 87%);
    
    //cards
    --primary-red: hsl(15, 100%, 70%);
    --soft-blue: hsl(195, 74%, 62%);
    --soft-red: hsl(348, 100%, 68%);
    --primary-lime:hsl(145, 58%, 55%);
    --primary-violet: hsl(264, 64%, 52%);
    --primary-orange: hsl(43, 84%, 65%);
    
    
    --theme-font: 'Rubik', sans-serif;
    --theme-font-size-base: 1.125rem; //18px
    --border-radius-base: 15px;
    --default-padding: 25px;

    
    --tile-light-bg: hsl(235, 45%, 95%);
    --tile-light-bg-hover:hsl(235, 45%, 65%);
    --tile-light-text: hsl(215, 60%, 45%);
  }
 
  html{
    background-color: var(--darkest-blue);
    height: 100%;
  }
  body{
    font-family: var(--theme-font);
    font-size: var(--theme-font-size-base);
    height: 100%;
    color: white;
    display: grid;
    place-items: center;
    min-height: 100vh;
    padding: clamp(1rem, 3rem, 4rem);

  }
  
  #root{
    height: 100%;
  }
`
export default GlobalStyle
